'use strict'

import Libraries from '@/pages/Library/LibraryList.vue'
import ifAuthenticated from '@/router/middleware'

export default [
  {
    path: '/:site/libraries',
    name: 'Libraries',
    component: Libraries,
    beforeEnter: ifAuthenticated
  }
]



// WEBPACK FOOTER //
// ./src/router/domains/library.js